import { render, staticRenderFns } from "./PageExploreClassmates.vue?vue&type=template&id=6830b447&scoped=true&"
import script from "./PageExploreClassmates.vue?vue&type=script&lang=js&"
export * from "./PageExploreClassmates.vue?vue&type=script&lang=js&"
import style0 from "./PageExploreClassmates.vue?vue&type=style&index=0&id=6830b447&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830b447",
  null
  
)

export default component.exports